@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.error-icon-wrapper {
  margin: -6px -6px 0 -5px;
  height: 20px;

  svg {
    color: @compact-error--icon-wrapper--fill-color;
    height: 26px;
    transform: scale(0.55);
  }
}

.error {
  display: flex;
  align-items: center;
  background-color: @compact-error--error--background-color;
  padding: 5px;
  border-radius: 5px;

  &.error-text {
    color: @compact-error--error--text-color;
    font-size: 14px;
    font-weight: @semi-bold;
    margin-left: 5px;

    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    color: @compact-error--error--fill-color;
  }
}

.warning {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.warning-text {
  color: @compact-error--display-text--text-color;
  padding: 0 4px;
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
}
